import { useMemo } from 'react'
import { ISchool } from 'interfaces/school.interface'
import { useSchoolContext } from '@/context/SchoolContext'

export interface UseSchoolDetailsState {
  loading: boolean
  error?: string
  schoolDetails?: ISchool | null
  refresh: () => Promise<void>
}

export function useSchoolDetails(): UseSchoolDetailsState {
  const {
    loading,
    error,
    schoolDetails,
    refresh,
  } = useSchoolContext()

  return useMemo(
    () => ({
      loading,
      error,
      schoolDetails,
      refresh,
    }),
    [
      loading,
      error,
      schoolDetails,
      refresh,
    ],
  )
}

export default useSchoolDetails
